import { useEffect, useRef } from 'react'
import { AppEventsContext } from '../../contexts/AppEventsContext'
import { ConversationContext } from './ConversationContext'

/**
 * Emits `conversation-opened` once per open request (`request.seq`) — the ONE place the event
 * fires, whatever entry point called `open`. Call it once per page, from the host
 * (`ArticleConversation`). Silent while the page has no registered container.
 */
export function useTrackConversationOpened(): void {
  const conversation = ConversationContext.useOptionalContainer()
  const appEvents = AppEventsContext.useOptionalContainer()
  const lastSeq = useRef(0)
  const request = conversation?.request ?? null
  const containerId = conversation?.containerId ?? null

  useEffect(() => {
    if (!request || !containerId || request.seq === lastSeq.current) {
      return
    }
    lastSeq.current = request.seq
    appEvents?.appEvent({ event: 'conversation-opened', source: request.source, containerId })
  }, [request, containerId, appEvents])
}
